import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import { api } from "../utils/api";
import Menu from "./Menu";
import { UserContext } from "../utils/UserContext";
import ExchangePopup from "./ExchangePopup";

const AllOrderPopup = ({ activeOrder, id, setActiveOrder, date, setNeedUpdate }) => {
  const [form, setForm] = useState({
    date: new Date(),
    user: "",
    status: "",
    total: 0,
    meals: [],
    _id: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [users, setUsers] = useState([]);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [mealToExchange, setMealToExchange] = useState(null);
  const [needUpdateLocal, setNeedUpdateLocal] = useState(true);
  const userContext = React.useContext(UserContext);
  const [limitType, setLimitType] = useState(null);
  const [cpfc, setCpfc] = useState(null);
  const [totalCpfc, setTotalCpfc] = useState(null);
  const [menu, setMenu] = useState(null);

  const formatMacro = (val) => {
    if (val === undefined || val === null) return "—";
    const num = Number(val);
    if (Number.isNaN(num)) return val;
    return num % 1 === 0 ? num : num.toFixed(1);
  };

  const closePopup = () => {
    setForm({
      date: new Date(),
      user: "",
      status: "",
      total: 0,
      meals: [],
      _id: "",
    });
    setActiveOrder(null);
    setNeedUpdate(true);
    setNeedUpdateLocal(true);
    setCpfc(null);
    setTotalCpfc(null);
  };

  useEffect(() => {
    if (!activeOrder || !needUpdateLocal) return;
    if (activeOrder.new === "new") {
      setForm({ ...form, date: activeOrder.date, user: activeOrder.user });
      return;
    }
    api
      .getOrder(activeOrder)
      .then(({ order, limitType }) => {
        order && setForm(order);
        setLimitType(limitType);
      })
      .finally(() => setNeedUpdateLocal(false));
  }, [activeOrder, needUpdateLocal]);

  const onSubmit = () => {
    setIsLoading(true);
    const { _id, meals, date, user } = form;
    if (_id === "") {
      api
        .postOrder({ meals, date, user })
        .then(() => {
          setNeedUpdate(true);
          closePopup();
        })
        .catch((err) => console.log(err))
        .finally(() => setIsLoading(false));
    } else {
      api
        .editOrder({ meals, date, _id, user })
        .then(() => {
          setNeedUpdate(true);
          closePopup();
        })
        .catch((err) => console.log(err))
        .finally(() => setIsLoading(false));
    }
  };

  const onDelete = () => {
    setIsLoading(true);
    api
      .deleteOrder(form._id)
      .then(() => {
        setNeedUpdate(true);
        closePopup();
      })
      .catch((err) => console.log(err))
      .finally(() => setIsLoading(false));
  };

  const mealAdd = ({ name, price, mealId }) => {
    if (form.meals.find((el) => el.mealId === mealId)) {
      setForm({
        ...form,
        meals: form.meals.map((el) =>
          el.mealId === mealId ? { ...el, amount: el.amount + 1 } : el
        ),
      });
    } else {
      setForm({
        ...form,
        meals: [...form.meals, { name, price, mealId, amount: 1 }],
      });
    }
    setIsMenuOpen(false);
  };

  const mealRemove = (mealId) => {
    setForm({
      ...form,
      meals: form.meals.filter((meal) => meal.mealId !== mealId),
    });
    setIsMenuOpen(false);
  };

  const mealSetAmount = (index, amount) => {
    if (amount <= 0) return;
    setForm({
      ...form,
      meals: form.meals.map((le, ind) => (index === ind ? { ...le, amount: amount } : le)),
    });
  };

  const payForMeal = (mealId, amount) => {
    api
      .payForMeal({
        orderId: form._id,
        mealId,
        amount,
      })
      .then(() => setNeedUpdateLocal(true));
  };

  const toggleSelfPay = (meal) => {
    const amount = meal.amountToPay > 0 ? 0 : meal.amount;
    payForMeal(meal._id, amount);
  };

  useEffect(() => {
    let total = 0;
    form.meals.forEach((meal) => (total += meal.price * meal.amount));
    setForm({ ...form, total });
  }, [form.meals]);

  useEffect(() => {
    api.getUsers({ p: 1, s: 1000 }).then(({ users }) => setUsers(users));
  }, []);

  useEffect(() => {
    api.getMeals({ p: 1, s: 10000 }).then(({ meals }) => setMenu(meals));
  }, []);

  useEffect(() => {
    if (!menu) return;
    if (form.meals.length <= 0) return;
    let Cc = 0,
      P = 0,
      F = 0,
      C = 0;
    setCpfc(
      form.meals.map((el) => {
        const found = menu.find((le) => le._id === el.mealId);
        if (found) {
          const { calories, proteins, fats, carbohydrates, weight, weightUnit } = found;
          if (
            !Boolean(calories) ||
            !Boolean(proteins) ||
            !Boolean(fats) ||
            !Boolean(carbohydrates) ||
            !Boolean(weight) ||
            !Boolean(weightUnit)
          )
            return null;
          Cc += Number(calories.toFixed(2)) * el.amount;
          P +=
            weightUnit === "Вес, г"
              ? Number(((proteins / 100) * weight).toFixed(2)) * el.amount
              : Number(proteins.toFixed(2));
          F +=
            weightUnit === "Вес, г"
              ? Number(((fats / 100) * weight).toFixed(2)) * el.amount
              : Number(fats.toFixed(2));
          C +=
            weightUnit === "Вес, г"
              ? Number(((carbohydrates / 100) * weight).toFixed(2)) * el.amount
              : Number(carbohydrates.toFixed(2));
          return {
            calories: calories.toFixed(2) * el.amount,
            proteins:
              weightUnit === "Вес, г"
                ? ((proteins / 100) * weight).toFixed(2) * el.amount
                : proteins.toFixed(2),
            fats:
              weightUnit === "Вес, г"
                ? ((fats / 100) * weight).toFixed(2) * el.amount
                : fats.toFixed(2),
            carbohydrates:
              weightUnit === "Вес, г"
                ? ((carbohydrates / 100) * weight).toFixed(2) * el.amount
                : carbohydrates.toFixed(2),
            weight,
            weightUnit,
          };
        }
        return null;
      })
    );
    setTotalCpfc({ Cc, P, F, C });
  }, [form, menu]);

  return (
    <>
      <Modal
        show={!!activeOrder}
        onHide={() => closePopup()}
        centered
        dialogClassName="order-modal"
        size="xl"
      >
        <Modal.Header closeButton>
          <div className="order-meta w-100">
            <div className="date">
              {new Date(form.date).toLocaleDateString("ru-RU", {
                weekday: "long",
                year: "numeric",
                month: "long",
                day: "numeric",
              })}
            </div>
            <span className="status-pill">
              {form.status === "ordered" ? "Заказано" : "Заявка"}
            </span>
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="order-summary">
            <div className="summary-card">
              <div className="summary-icon total">
                <i className="bi bi-wallet2" />
              </div>
              <div className="summary-content">
                <div className="summary-title">Итого</div>
                <div className="summary-value">{form.total} ₽</div>
              </div>
            </div>
            <div className="summary-card">
              <div className="summary-icon user">
                <i className="bi bi-person-circle" />
              </div>
              <div className="summary-content">
                <div className="summary-title">Пользователь</div>
                <div className="summary-value">
                  {users.find((u) => u._id === form.user)?.name || ""}
                </div>
              </div>
            </div>
            {limitType === "meals" ? (
              <div className="summary-card">
                <div className="summary-icon selfpay">
                  <i className="bi bi-piggy-bank" />
                </div>
                <div className="summary-content">
                  <div className="summary-title">Самооплата</div>
                  <div className="summary-value">
                    {form.meals.reduce((prev, cur) => prev + cur.amountToPay, 0)}
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}
            {totalCpfc ? (
              <div className="summary-card">
                <div className="summary-icon nutrition">
                  <i className="bi bi-graph-up" />
                </div>
                <div className="summary-content">
                  <div className="summary-title">Рацион</div>
                  <div className="summary-macros">
                    <span className="macro-pill macro-pill__cal">
                      {formatMacro(totalCpfc.Cc)} ккал
                    </span>
                    <span className="macro-pill macro-pill__p">
                      Б {formatMacro(totalCpfc.P)}
                    </span>
                    <span className="macro-pill macro-pill__f">
                      Ж {formatMacro(totalCpfc.F)}
                    </span>
                    <span className="macro-pill macro-pill__c">
                      У {formatMacro(totalCpfc.C)}
                    </span>
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
          <div className="order-list order-list--modal mb-3">
            {form.meals.map((meal, index) => {
              const isOnExchange = (meal.onChangeAmount || 0) > 0;
              const selfPayEnabled = limitType === "meals" && form.status === "ordered";
              return (
                <div
                  className={`order-list__item order-modal-item${
                    isOnExchange ? " on-exchange" : ""
                  }`}
                  key={meal._id}
                >
                  <div className="order-item__main">
                    <div className="order-title-row">
                      <div className="fw-semibold title-name">
                        {meal.name}
                        {isOnExchange ? (
                          <span
                            className="exchange-pill icon-pill ms-2"
                            title={`На аукционе (${meal.onChangeAmount})`}
                          >
                            <i className="bi bi-arrow-left-right" />
                          </span>
                        ) : (
                          ""
                        )}
                      </div>
                      <div className="title-actions">
                        {userContext.access.editOrderedOrders || form.status !== "ordered" ? (
                          <Button
                            size="sm"
                            variant="outline-secondary"
                            className="action-btn"
                            onClick={() => mealRemove(meal.mealId)}
                          >
                            <i className="bi bi-trash" />
                            Удалить
                          </Button>
                        ) : (
                          ""
                        )}
                        {userContext.access.exchange &&
                        (meal.onChangeAmount || 0) <= 0 &&
                        form.status === "ordered" ? (
                          <Button
                            size="sm"
                            variant="outline-primary"
                            className="action-btn"
                            onClick={() =>
                              setMealToExchange({
                                orderId: form._id,
                                name: meal.name,
                                price: meal.price,
                                mealId: meal.mealId,
                                amount: meal.amount,
                              })
                            }
                          >
                            <i className="bi bi-box-arrow-up-right" />
                            Отдать
                          </Button>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                    <div className="text-muted small">
                      {menu?.find((le) => le._id === meal.mealId)?.subName || ""}
                    </div>
                    <div className="text-muted order-macro">
                      {cpfc && cpfc[index]
                        ? cpfc[index].weightUnit === "Вес, г"
                          ? `ккал: ${cpfc[index].calories} · белки: ${cpfc[index].proteins} · жиры: ${cpfc[index].fats} · углеводы: ${cpfc[index].carbohydrates}`
                          : `ккал: ${cpfc[index].calories} · белки/100г: ${cpfc[index].proteins} · жиры/100г: ${cpfc[index].fats} · углеводы/100г: ${cpfc[index].carbohydrates}`
                        : ""}
                    </div>
                  </div>
                  <div className="order-item__meta">
                    <div className="meta-row meta-qty">
                      <div className="order-amount-control justify-content-center">
                        {userContext.access.editOrderedOrders || form.status !== "ordered" ? (
                          <>
                            <Button
                              size="sm"
                              variant="light"
                              className="counter-btn"
                              onClick={() => mealSetAmount(index, Number(meal.amount) - 1)}
                            >
                              -
                            </Button>
                            <span className="fw-semibold">{meal.amount}</span>
                            <Button
                              size="sm"
                              variant="light"
                              className="counter-btn"
                              onClick={() => mealSetAmount(index, Number(meal.amount) + 1)}
                            >
                              +
                            </Button>
                          </>
                        ) : (
                          <span className="fw-semibold">{meal.amount}</span>
                        )}
                      </div>
                      <div className="order-price-line">
                        <span className="order-price">× {meal.price} ₽</span>
                        <span className="order-sum">{meal.price * meal.amount} ₽</span>
                      </div>
                    </div>
                    {selfPayEnabled ? (
                      <div className="meta-row meta-top">
                        <Button
                          size="sm"
                          variant={meal.amountToPay > 0 ? "success" : "outline-secondary"}
                          className="meta-selfpay"
                          onClick={() => toggleSelfPay(meal)}
                        >
                          {meal.amountToPay > 0
                            ? `Сам оплачиваю (${meal.amountToPay})`
                            : "Отметить оплату"}
                        </Button>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              );
            })}
            <div className="order-list__total">
              <span>Итого</span>
              <span className="order-total-value">{form.total} ₽</span>
            </div>
          </div>
      {userContext.access.editOrderedOrders || form.status !== "ordered" ? (
        <div className="order-inline-action">
          <Button variant="outline-primary" className="w-100" onClick={() => setIsMenuOpen(true)}>
            <i className="bi bi-plus-lg me-2" />
            Добавить блюдо
          </Button>
        </div>
      ) : (
        ""
      )}
    </Modal.Body>
    <Modal.Footer className="d-flex flex-wrap gap-2 justify-content-between">
      <div className="text-muted small">
        {limitType === "meals"
          ? `Самооплата: ${form.meals.reduce((prev, cur) => prev + cur.amountToPay, 0)}`
          : ""}
      </div>
      <div className="d-flex gap-2 flex-wrap">
        <Button variant="outline-secondary" onClick={() => closePopup()} disabled={isLoading}>
          Отмена
        </Button>
        {form._id ? (
          <>
            <Button variant="outline-danger" onClick={() => onDelete()} disabled={isLoading}>
              Удалить
            </Button>
            <Button variant="primary" onClick={() => onSubmit()} disabled={isLoading}>
              Сохранить
            </Button>
          </>
        ) : (
          <Button variant="primary" onClick={() => onSubmit()} disabled={isLoading}>
            Создать
          </Button>
        )}
      </div>
    </Modal.Footer>
      </Modal>
      <Menu isOpen={isMenuOpen} setIsOpen={setIsMenuOpen} onAdd={mealAdd} />
      {mealToExchange ? (
        <ExchangePopup
          meal={mealToExchange}
          setMeal={setMealToExchange}
          setNeedUpdate={setNeedUpdate}
        />
      ) : (
        ""
      )}
    </>
  );
};

export default AllOrderPopup;
